import reducer, { actions } from './slice'
import * as selectors from './selectors'
import * as statelessActions from './actions'

export { selectors, actions, statelessActions }

export default reducer
